// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3livU","colBig":"styles_colBig__17xms","colSmall":"styles_colSmall__hHCtk"};